/* eslint-disable */
const wait = ms => new Promise(r => setTimeout(r, ms));

export const retryOperation = (operation, params, delay, retries) =>
    new Promise((resolve, reject) => {
        return operation(params)
            .then(resolve)
            .catch(reason => {
                if (retries > 0) {
                    return wait(delay)
                        .then(
                            retryOperation.bind(
                                null,
                                operation,
                                params,
                                delay,
                                retries - 1
                            )
                        )
                        .then(resolve)
                        .catch(reject);
                }
                return reject(reason);
            });
    });
